export var GppCommand;
(function (GppCommand) {
    GppCommand["ADD_EVENT_LISTENER"] = "addEventListener";
    GppCommand["GET_FIELD"] = "getField";
    GppCommand["GET_SECTION"] = "getSection";
    GppCommand["HAS_SECTION"] = "hasSection";
    GppCommand["PING"] = "ping";
    GppCommand["REMOVE_EVENT_LISTENER"] = "removeEventListener";
})(GppCommand || (GppCommand = {}));
